// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__F2Y75","rodapeContato":"Rodape_rodapeContato__JMmJ1"};